<template>
    <AutoNumericVue 
    :value="modelValue"
    :disabled ='disabled'
    class="form-control outline-none px-3 py-2 rounded-md text-white border-0 w-full bg-black-body"
    :placeholder="supplyPlaceholder"
    :options="{
      showWarnings : false,
      digitGroupSeparator: ',',
      decimalCharacter: '.',
      currencySymbol: '',
      allowDecimalPadding: false,
      decimalPlaces: decimal,
      roundingMethod: 'U',
      minimumValue: '0',
      maximumValue: maxValue
    }"
    @input="$emit('update:modelValue',parseFloat($event.target.value.replace(/,/g, '')).toString())"
    ></AutoNumericVue>
</template>

<script>
import AutoNumericVue from 'autonumeric-vue/src/components/AutoNumericVue';
export default{
  name: 'tokensSupplyInputComponent',
  props: {
    modelValue: String,
    disabled: Boolean,
    decimal: Number,
    maxValue: String,
    supplyPlaceholder: String,
  },
  components:{
    AutoNumericVue
  },

  emits:[
    'update:modelValue'
  ],
}
</script>
<style lang="scss" scoped>
// @import "@/assets/scss/global.scss";
/* Chrome, Safari, Edge, Opera */
// input::-webkit-outer-spin-button,
// input::-webkit-inner-spin-button {
//   -webkit-appearance: none;
//   margin: 0;
// }

// /* Firefox */
// input[type=number] {
//   -moz-appearance: textfield;
// }

// .supply_input{
//   @apply w-full flex border-0 outline-none border-white drop-shadow-none filter focus:outline-none text-sm text-gray-text font-bold disabled:opacity-50;
// }
</style>